import React from "react";
import {Book} from "react-feather";
import ReportingPeriods from "../periods/index";
import GrantAccountStatements from "../statements/index";
import GrantAccountStatementForm from "../statements/form";
import GrantDetails from "../grant/index";
import GrantDetailForm from "../grant/form";
import ReportingPeriodForm from "../periods/form";
import GasCountries from "../countries";
import GasCountryForm from "../countries/form";
import GasEmailTemplates from "../templates/index";
import GasEmailTemplateForm from "../templates/form";


export const GasMenuRoutes = {
    id: "Grant Statements",
    path: "/gas",
    right: ['ROLE_GAS_ADMIN'],
    icon: <Book />,
    children: [
        {path: "/gas/account-statements", component: GrantAccountStatements, name: "Distribution Manager"},
        {path: "/gas/countries", component: GasCountries, name: "Countries"},
        {path: "/gas/grants", component: GrantDetails, name: "Grants"},
        {path: "/gas/reporting-periods", component: ReportingPeriods, name: "Reporting Periods"},
        {path: "/gas/templates", component: GasEmailTemplates, name: "Email Templates"},

    ], component: null
}

export const GasFormRoutes = {
    children: [
        {path: "/gas/account-statements/:id", component: GrantAccountStatements, name: "Distribution Manager"},
        {path: "/gas/reporting-period/:id", component: ReportingPeriodForm, name: "Reporting Period"},
        {path: "/gas/grant/:id", component: GrantDetailForm, name: "Grant Detail Form"},
        {path: "/gas/account-statement/:id", component: GrantAccountStatementForm, name: "Grant Account Statement"},
        {path: "/gas/country/:id", component: GasCountryForm, name: "GAS Country"},
        {path: "/gas/template/:id", component: GasEmailTemplateForm, name: "Template"}
    ]
}